export const leaveApplicationFields = [
  {
    name: "startDate",
    label: "Start Date",
    type: "date",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "endDate",
    label: "End Date",
    type: "date",
    required: true,
    gridColumn: "span 2",
  },

  {
    name: "autoAccessDocuments",
    label: "Access Documents?",
    type: "checkbox",
    gridColumn: "span 2",
  },
  {
    name: "autoAccessCase",
    label: "Access Case?",
    type: "checkbox",
    gridColumn: "span 2",
  },
];
export const leavePolicyFields = [
  {
    name: "gender",
    label: "Gender",
    type: "select",
    options: [
      { label: "Male", value: 1 },
      { label: "Female", value: 2 },
      { label: "Other", value: 3 },
    ],
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "acrues",
    label: "Acrues",
    type: "checkbox",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "accrualRate",
    label: "Accrual Rate",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "accrualDate",
    label: "Accrual Date",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "canCarryForward",
    label: "Can Carry Forward",
    type: "checkbox",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "maxDaysCarryForward",
    label: "Max Days Carry Forward",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "maxOpenApplications",
    label: "Max Open Applications",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
  {
    name: "maxDays",
    label: "Max Days",
    type: "number",
    required: false,
    gridColumn: "span 2",
  },
];
export const CompanyCalendarSetupsFormFields = [
  { name: "holiday", label: "Holiday", type: "text", required: true },

  {
    name: "holidayDate",
    label: "Holiday Date",
    type: "date",
    gridColumn: "span 2",
    required: true,
    disableCondition: {
      fieldName: "recurringTypeId",
      value: 2,
    },
  },
];

export const imprestApplicationsForms = [
  {
    name: "amount",
    label: "Amount",
    type: "number",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "title",
    label: "Title",
    type: "text",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    required: true,
    gridColumn: "span 2",
  },

  {
    name: "isPettyCash",
    label: "Is this a Petty Cash?",
    type: "checkbox",
    required: false,
    gridColumn: "span 1",
  },
  {
    name: "caseRelated",
    label: "Case Related?",
    type: "checkbox",
    required: false,
    gridColumn: "span 1",
    parent: "main",
  },
];
export const staffClaimsFields = [
  {
    name: "title",
    label: "Title",
    type: "text",
    required: true,
    gridColumn: "span 2",
  },
  {
    name: "description",
    label: "Description",
    type: "text",
    required: true,
    gridColumn: "span 2",
  },
];
